import { render } from "./MePoint.vue?vue&type=template&id=dcd27a3c&scoped=true"
import script from "./MePoint.vue?vue&type=script&lang=js"
export * from "./MePoint.vue?vue&type=script&lang=js"

import "./MePoint.vue?vue&type=style&index=0&id=dcd27a3c&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd27a3c"]])

export default __exports__